// Navigation des Moduls `assistent` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul assistent.
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'assistent',
  title: 'AI engine & MCP',
});
